import { formatDistance } from 'date-fns';
import { tr } from 'date-fns/locale';

// USDT MODE - Tüm fiyatlar dolar sembolü olmadan

export const formatPrice = (price) => {
  if (!price) return null;
  // Fiyat büyüklüğüne göre ondalık basamak
  if (price >= 1000) {
    return price.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
  let decimals;
  if (price >= 100) {
    decimals = 2;
  } else if (price >= 1) {
    decimals = 4;
  } else {
    decimals = 4;  // TRX gibi düşük fiyatlı coinler için 4 hane
  }
  return price.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

export const formatLivePrice = (price) => {
  if (!price) return '-';
  // Fiyat büyüklüğüne göre ondalık basamak
  if (price >= 1000) {
    return price.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
  let decimals;
  if (price >= 100) {
    decimals = 2;
  } else if (price >= 1) {
    decimals = 4;
  } else {
    decimals = 4;  // TRX gibi düşük fiyatlı coinler için 4 hane
  }
  return price.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

export const formatTime = (dateString) => {
  try {
    return formatDistance(new Date(dateString), new Date(), { addSuffix: true, locale: tr });
  } catch {
    return '';
  }
};

// v10.6 - Normalize advice text: Emir kipi → Basit Türkçe
// On-the-fly dönüşüm, DB'ye dokunmadan eski metinleri anlaşılır hale getirir
export const normalizeAdvice = (text) => {
  if (!text) return text;
  
  let normalized = text;
  
  // Emir kipi → Basit Türkçe dönüşüm map'i (option a - en basit dil)
  const replacements = [
    // Kâr alma emirleri → Basit dil
    ['Kısmi kâr al', 'Kısmen satış değerlendirilebilir'],
    ['kısmi kâr al', 'kısmen satış değerlendirilebilir'],
    ['Kârını al', 'Satış değerlendirilebilir'],
    ['kârını al', 'satış değerlendirilebilir'],
    ['Kârının bir kısmını güvene al', 'Kısmen satış değerlendirilebilir'],
    ['güvene alabilirsin', 'değerlendirilebilir'],
    ['Kâr kilitleme mantıklı olabilir', 'Kârın bir kısmı güvenceye alınabilir'],
    ['Kâr kilitleme değerlendirmesi mantıklı olabilir', 'Kârın bir kısmı güvenceye alınabilir'],
    ['Kısmi kâr kilitleme değerlendirilebilir', 'Kârın bir kısmı güvenceye alınabilir'],
    ['kısmi kâr kilitleme değerlendirilebilir', 'kârın bir kısmı güvenceye alınabilir'],
    ['Kâr kilitleme', 'Kârın bir kısmı güvenceye alınabilir'],
    ['kâr kilitleme', 'kârın bir kısmı güvenceye alınabilir'],
    
    // Stop emirleri → Basit dil (option a)
    ['Trailing stop kullan', 'Stop seviyesi yükseltilebilir'],
    ['trailing stop kullan', 'stop seviyesi yükseltilebilir'],
    ['Korumalı takip düşünülebilir', 'Stop seviyesi yükseltilebilir'],
    ['korumalı takip düşünülebilir', 'stop seviyesi yükseltilebilir'],
    ['Korumalı takip', 'Stop seviyesi yükseltilebilir'],
    ['korumalı takip', 'stop seviyesi yükseltilebilir'],
    ['Stop\'u yükselt', 'Stop seviyesi yükseltilebilir'],
    ['stop\'u yükselt', 'stop seviyesi yükseltilebilir'],
    ['Stop güncellemesi değerlendirilebilir', 'Stop seviyesi yükseltilebilir'],
    ['Stop yukarı çekilebilir', 'Stop seviyesi yükseltilebilir'],
    ['stop yukarı çekilebilir', 'stop seviyesi yükseltilebilir'],
    ['Stop takibi', 'Stop seviyesi takibi'],
    ['stop takibi', 'stop seviyesi takibi'],
    ['Stop koy', 'Stop belirlenmeli'],
    ['stop koy', 'stop belirlenmeli'],
    ['Risk sıfırlama değerlendirilebilir', 'Stop giriş fiyatına çekilebilir'],
    ['Risk sıfırlama', 'Stop güncelleme'],
    
    // Genel emirler → Basit dil
    ['Sabırla bekle', 'Takip edilmeli'],
    ['sabırla bekle', 'takip edilmeli'],
    ['Sabırlı ol', 'Takipte'],
    ['sabırlı ol', 'takipte'],
    ['Panik yapma', 'Plan geçerli'],
    ['panik yapma', 'plan geçerli'],
    ['Bekle', 'Takip edilmeli'],
    ['bekle', 'takip edilmeli'],
    ['izleme sıklaştırılabilir', 'dikkatli takip edilmeli'],
    ['İzleme sıklaştırılabilir', 'Dikkatli takip edilmeli'],
    
    // Robotik dil dönüşümleri
    ['Mevcut SELL pozisyonu', 'SHORT pozisyon'],
    ['Mevcut BUY pozisyonu', 'LONG pozisyon'],
    ['Mevcut sell pozisyonu', 'SHORT pozisyon'],
    ['Mevcut buy pozisyonu', 'LONG pozisyon'],
    ['pozisyonu takip ediliyor', 'aktif'],
    ['senaryo geçerli', 'devam ediyor'],
    
    // Ana hedef ifadeleri
    ['Ana hedef geçildi', 'Ana hedefe ulaşıldı'],
    ['İlk hedef geçildi', 'İlk hedefe ulaşıldı'],
    
    // Trailing stop Türkçeleştirme (option a)
    ['trailing stop', 'stop seviyesi takibi'],
    ['Trailing Stop', 'Stop Seviyesi Takibi'],
  ];
  
  // Tüm dönüşümleri uygula
  for (const [from, to] of replacements) {
    normalized = normalized.replace(new RegExp(from, 'g'), to);
  }
  
  // Eğer hala emir kipi içeriyorsa (al, sat, kullan, yap, kapat, çek)
  // ve cümle 80 karakterden kısaysa, fallback uygula
  const commandPatterns = /\b(kâr al|kar al|satın al|kullan|stop koy|kapat|güvene al)\b/i;
  if (commandPatterns.test(normalized) && normalized.length < 100) {
    // Fallback: Genel basit cümle
    return 'Pozisyon takipte. Piyasa izleniyor.';
  }
  
  return normalized;
};

// Helper functions for signal data
export const getTargetPrice = (signal) => signal.tp2 || signal.target_price || signal.take_profit_price || null;
export const getStopLoss = (signal) => signal.stop_loss || signal.stop_loss_price || null;
export const getTP1 = (signal) => signal.tp1 || null;
export const getTP3 = (signal) => signal.tp3 || null;
